import React from 'react';
// FIX: Adicionada a extensão .jsx para garantir que o Vite encontre o arquivo corretamente
import { ServiceCard } from '../layout/LegalDesignUI';

export const PracticeAreas = () => {
  // BLINDAGEM: Se ServiceCard falhar na importação (undefined), usa um fallback simples
  const CardComponent = ServiceCard || (({ title, description }) => (
    <div className="p-4 border rounded bg-red-50 text-red-800">
      <h3 className="font-bold">{title}</h3>
      <p>{description}</p>
      <p className="text-[10px] mt-2 text-red-500">* Erro ao carregar estilo visual (ServiceCard)</p>
    </div>
  ));

  return (
    <div className="py-20 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-6">
        
        {/* CABEÇALHO DA SEÇÃO */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#20243B] mb-6 relative inline-block">
            Áreas de Atuação
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#C5A059]"></div>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Advocacia artesanal focada na excelência técnica e na estratégia processual. 
            Não atuamos em massa; atuamos com precisão.
          </p>
        </div>

        {/* GRID DE ÁREAS (LAYOUT 3 COLUNAS) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          
          {/* 1. DIREITO ANIMAL (CORE - ORDEM DE GRAVIDADE) */}
                    <CardComponent 
            icon="fa-paw" 
            title="Direito Animal" 
            description="Atuação pioneira na defesa de direitos não-humanos. Combate rigoroso a maus-tratos, ações de indenização por dano animal, tutela de animais em divórcios e direito condominial pet-friendly." 
          />
          
                    {/* 2. CRIMINAL (TÉCNICO - SEM JÚRI) */}
          <CardComponent 
            icon="fa-gavel" 
            title="Criminal e Execução" 
            description="Defesa técnica em inquéritos e ações penais, com atuação em Execução Penal (Progressão de Regime, Livramento Condicional e Remição) e Revisão Criminal."
          />
          
          {/* 3. CONTRATOS (EXTRAJUDICIAL - SEM BANCÁRIO GENÉRICO) */}
          <CardComponent 
            icon="fa-handshake" 
            title="Contratos e Acordos" 
            description="Atuação focada em resolução extrajudicial de conflitos. Elaboração e revisão estratégica de contratos, blindagem jurídica e negociação de acordos complexos."
          />
          
          {/* 4. FAMÍLIA (MULTIESPÉCIE - TEXTO CORRETO) */}
          <CardComponent 
            icon="fa-users" 
            title="Família e Sucessões" 
            description="Divórcios judiciais e extrajudiciais. Foco especial em Guarda e Convivência de dependentes vulneráveis (animais humanos e animais não-humanos)." 
          />
          
          {/* 5. EDUCACIONAL (VALIDADO POR DADOS) */}
          <CardComponent 
            icon="fa-graduation-cap" 
            title="Direito Educacional" 
            description="Defesa de alunos e professores em demandas envolvendo Instituições de Ensino (matrícula, FIES, processos disciplinares) e validação de diplomas." 
          />
          
          {/* 6. ADMINISTRATIVO (SERVIDOR) */}
          <CardComponent 
            icon="fa-building-columns" 
            title="Direito Administrativo" 
            description="Defesa de servidores públicos em Processos Administrativos Disciplinares (PAD), anulação de atos administrativos, concursos públicos e Mandados de Segurança." 
          />

        </div>

        {/* CHAMADA PARA AÇÃO */}
        <div className="mt-20 text-center bg-white p-10 rounded-2xl shadow-sm border border-gray-200">
            <h3 className="text-2xl font-bold text-[#20243B] mb-4">Seu caso demanda análise técnica?</h3>
            <p className="text-gray-600 mb-8">Agende uma consulta inicial para diagnóstico jurídico detalhado.</p>
            <a 
                href="https://wa.me/5541998481711?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta%20jur%C3%ADdica." 
                target="_blank" 
                rel="noreferrer"
                className="inline-block bg-[#C5A059] text-[#20243B] font-bold px-8 py-4 rounded-lg uppercase tracking-wider hover:bg-[#b08d4b] transition-colors shadow-lg"
            >
                <i className="fab fa-whatsapp mr-2"></i> Falar com o Advogado
            </a>
        </div>
      </div>
    </div>
  );
};